import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux";
import { createCategory, deleteTimeslotByCategory, updateCategory } from "../../redux/reducer/timeslotReducer";
import BoxColorService from "../boxColorService";
import BoxEmailService from "../boxEmailService";
import BoxOpacity from "../boxOpacity";
import CheckboxOption from "../checkboxOption";
import ButtonDanger from "../common/buttonDanger";
import ButtonSubmit from "../common/buttonSubmit";
import ButtonWhite from "../common/buttonWhite";
import Textarea from "../common/textArea";
import TitleModal from "../common/titleModal";
import PopUpDeleteTimeslotByService from "./popUpDeleteTimeslotByService";
import InputFiled from "../common/inputFiled";
import SelectBox from "../common/selectBox";
import ErrorMessageBox from "../common/errorMessageBox";
import { useTranslation } from "react-i18next";
import InputSwitch from "../common/inputSwitch";
import AutoComplite from "../common/autoComplite";
import AlertMessage from "../alertMessage";
import { isGroupLinkChild } from "../../utils/helpers";



const PopUpEditService = (props: any) => {
  let show = props.show ?? false;
  let id = props.id ?? "";
  let internalServiceNames = props.internalServiceNames ?? []
  const dispacth = useAppDispatch()
  const { t } = useTranslation();

  const { categoryPrenotation } = useSelector((state: any) => state.timeslot);
  const { eventHash } = useSelector((state: any) => state.login);
  const [checkNotification, setCheckNotification] = useState("No");
  const [description, setDescription] = useState("");
  const [titleModal, setTitleModal] = useState("");
  const [minutesBeforeClosing, setMinutesBeforeClosing] = useState(0);
  const [timeType, setTimeType] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [color, setColor] = useState("#683AB7")
  const [categorySlug, setCategorySlug] = useState("");
  const [showDeleteService, setShowDeleteService] = useState(false)
  const [external, setExternal] = useState(true);
  const [hideCategory, setHideCategory] = useState(true);
  const [isChildCategory, setIsChildCategory] = useState(false);
  const [unlinkCategory, setUnlinkCategory] = useState(false);
  const paramsTimeType = [
    [t('minutes'), "minuti"],
    [t('hours'), "ore"]
  ]

  let emailsArray: any[] = [];
  const [emails, setEmails] = useState(emailsArray);
  const Update = (email: any) => {
    setEmails(email);
  }
  useEffect(() => {
    InitService()
  }, [id])
  const InitService = () => {
    let category = categoryPrenotation.find((category: any) => category._id === id);
    setTitleModal(category?.name);
    setExternal(category?.external);
    setDescription(category?.description);
    setColor(category?.color);
    setCategorySlug(category?.categorySlug);
    setEmails(category?.emails);
    setHideCategory(category?.hideAgenda);
    setIsChildCategory(isGroupLinkChild(category?.groupLink));
    setUnlinkCategory(category?.groupLink?.disabled);
    setErrorMessage("");
    if (category?.emails.length) {
      setCheckNotification("Si")
    }
    else {
      setCheckNotification("No")
    }
    let minutesBeforeClosing = category?.minutesBeforeClosing || 0;

    if (minutesBeforeClosing % 60 === 0 && minutesBeforeClosing > 0) {
      setTimeType("ore");
      setMinutesBeforeClosing(minutesBeforeClosing / 60)
    }
    else {
      setTimeType("minuti");
      setMinutesBeforeClosing(minutesBeforeClosing)
    }
  }
  const saveService = async () => {
    try {
      let timeslotCategory: any = {
        emails: emails,
        description: description,
        color: color,
        hideAgenda: hideCategory,
        minutesBeforeClosing: minutesBeforeClosing,
        name: titleModal,
        unlinkCategory: unlinkCategory,
      }
      if (checkNotification === "No") {
        timeslotCategory.emails = []
      }
      if (timeType === "ore" && timeslotCategory.minutesBeforeClosing > 0) {
        timeslotCategory.minutesBeforeClosing = timeslotCategory.minutesBeforeClosing * 60;
      }
      if (id === "new") {
        await dispacth(createCategory(timeslotCategory));

      }
      else {
        timeslotCategory._id = id;
        await dispacth(updateCategory(timeslotCategory));

      }
      props.closeModal(false)
    }
    catch (error: any) {
      setErrorMessage(t(`error.${error.response.data.result.key || "generic"}`))
    }
  }

  const deleteTimeslotCategory = async () => {
    await dispacth(deleteTimeslotByCategory(id));
    setShowDeleteService(false)
    props.closeModal(false)
  }
  const openPreview = () => {
    const params = [
      `category=${categorySlug}`,
      // Category param is used to filter client side after fetching.
      // Client needs to fetch with the right `external` param
      // otherwise category will not be found.
      `external=${external ? 1 : 0}`,
    ]
    window.open(
      `${process.env.REACT_APP_GUESTAPP}/calendar/event/${eventHash}?${params.join('&')}`,
      '_blank',
      'noopener,noreferrer'
    );
  }

  const setTitle = (value: any) => {
    setTitleModal(value.value)
  }
  return (
    <>
      <Modal className="ModalSection EditCategoryTimeslot" show={show && !showDeleteService} onHide={props.closeModal}>
        <Modal.Header closeButton>
          <div>
            <h5>{t('popup-edit-service.set-service') as String}</h5>
            {(external === true) && <p>{titleModal}</p>}
          </div>
        </Modal.Header>
        <Modal.Body>

          {(!external) &&
            <>
              <TitleModal title={t('name-service') + ' *'} />
              <AutoComplite height={"32"} firstSelect={titleModal} params={internalServiceNames.filter((internalServiceName: any) => !internalServiceName.disabled)} handleChange={setTitle} />
            </>
          }

          <TitleModal title={t('description')} />
          <Textarea value={description} handleChange={setDescription} />
          <TitleModal title={t('popup-edit-service.notific-email')} />
          <CheckboxOption value={checkNotification} handleChange={setCheckNotification} />
          <BoxOpacity visible={(checkNotification !== "Si")}>
            <TitleModal title={t('popup-edit-service.insert-email')} />
            <BoxEmailService handelUpdate={Update} emails={emails} />
          </BoxOpacity >
          <TitleModal title={t('popup-edit-service.choose-color') + ' *'} />
          <BoxColorService changeColor={setColor} colorId={color} />
          <TitleModal title={t('popup-edit-service.label-minutes-before-closing')} />
          <div className="row mb-4">
            <div className="col-lg-5">
              <InputFiled min={0} type="number" value={minutesBeforeClosing} name="numberWaitTime" handleChange={setMinutesBeforeClosing} />
            </div>
            <div className="col-lg-5">
              <SelectBox handleChange={setTimeType} value={timeType} params={paramsTimeType} />

            </div>
          </div>
          <InputSwitch checked={hideCategory} onChange={setHideCategory} nameComponent="hideAgenda" label={t('popup-edit-service.label-hide-agenda')} />
          <AlertMessage description={t('popup-edit-service.description-hide-agenda')}
            additionalClass="mt-4" />

          {(isChildCategory || unlinkCategory) && <>
            <InputSwitch checked={unlinkCategory} disabled={unlinkCategory} onChange={setUnlinkCategory} nameComponent="unlinkAgenda" label={t('popup-edit-service.label-unlink-agenda')} />
            <AlertMessage description={t('popup-edit-service.description-unlink-agenda')}
              additionalClass="mt-4" />
          </>}

          <p className="text-danger pt-2">{t('required-fields')}</p>
          <div className="col-12 mb-4">
            <ErrorMessageBox errorMessage={errorMessage} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-6" title={isChildCategory ? t("popup-edit-service.linked-child-delete-title") : ""}>
                {(id !== "new") && <ButtonDanger
                  textButton={t('popup-edit-service.delete-service')}
                  handleChange={() => (setShowDeleteService(true))}
                  disabled={isChildCategory}
                />}
              </div>
              <div className="col-lg-6 text-right">
                {(id !== "new" && !hideCategory) && <ButtonWhite textButton={t('label-preview')} handleChange={() => (openPreview())} />}
                <ButtonSubmit textButton={t('save')} handleChange={saveService} />
              </div>
            </div>
          </div>

        </Modal.Footer>
      </Modal>


      <PopUpDeleteTimeslotByService
        handleCloseSecondary={() => (setShowDeleteService(false))}
        handleClosePrimary={() => (deleteTimeslotCategory())}
        closeModal={() => (setShowDeleteService(false))}
        id={id}
        show={showDeleteService} />
    </>
  )
}

export default PopUpEditService;